<template>
  <div class="container">
    <van-sticky class="navbar">
      <van-nav-bar
        title="就餐码"
        right-text="就餐记录"
        left-arrow
        @click-left="goback()"
        @click-right="goRecord()"
      />
    </van-sticky>
    <div class="header">
      <div class="title">今日就餐次数剩余：{{ times }}</div>
      <div class="date">{{ currentDate }}</div>
    </div>
    <div class="qrcode_wrapper">
      <div class="qrcode_content">
        <div class="user_info">
          <img src="../../assets/logo.png" alt="" />
          <div class="user_right">
            <div class="name">{{ trueName }}</div>
            <div class="company">河北宜农科技股份有限公司</div>
          </div>
        </div>
        <div class="qrcode">
          <div class="ball"></div>
          <div class="ball2"></div>
          <!-- <vue-qr
            v-show="times > 0"
            class="qrcode_img"
            :margin="10"
            :text="qrcodeValue"
          ></vue-qr> -->
          <div class="qrcode_img" v-show="times > 0" ref="qrCodeUrl"></div>
          <img
            v-show="times === 0"
            src="../../assets/no_times.png"
            class="tip_img"
            alt=""
          />
          <div class="tip">
            {{
              times > 0
                ? "就餐请出示二维码"
                : times === 0
                ? "今日次数已用完！"
                : ""
            }}
          </div>
          <span
            v-show="times > 0"
            style="display:inline-block;padding: 10px 20px;font-size: 20px"
            @click="getInfo"
          >
            <van-icon color="#f7b52b" name="replay" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
import { mapMutations } from "vuex";
// import VueQr from "vue-qr";
import { getUserInfo } from "@/api/canteen";
import QRCode from "qrcodejs2";
export default {
  name: "eatCode",
  components: {
    // VueQr
  },
  data() {
    return {
      currentDate: "",
      qrcodeValue: "",
      timmer: null,
      times: 0,
      trueName: "",
      timer: null
    };
  },
  mounted() {
    // this.creatQrCode();
    if (window.localStorage.getItem("")) {
      this.getInfo();
    } else {
      this.$router.push("/canteenForUser/login");
    }
  },
  created() {
    this.handleDisableScale();
  },
  methods: {
    ...mapMutations(["delUser"]),
    goback() {
      Dialog.confirm({
        title: "",
        message: "确定退出登录吗？",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        this.delUser();
        this.$router.push("/canteenForUser/login");
      });
    },
    goRecord() {
      this.$router.push("/canteenForUser/eatRecord");
    },
    handleDisableScale() {
      window.onload = function() {
        document.addEventListener("touchstart", function(event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        });
        document.addEventListener("gesturestart", function(event) {
          event.preventDefault();
        });
      };
    },
    creatQrCode(code) {
      this.$refs.qrCodeUrl.innerHTML = "";
      this.$nextTick(() => {
        new QRCode(this.$refs.qrCodeUrl, {
          text: code, // 需要转换为二维码的内容
          colorDark: "#000000",
          colorLight: "#ffffff",
          width: 180,
          height: 180,
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    getInfo() {
      getUserInfo({}).then(res => {
        if (res.code == 200) {
          this.creatQrCode(res.data.code);
          this.currentDate = res.data.date;
          this.trueName = res.data.trueName;
          this.times = 0;
          if (res.data.hasBreakfast) this.times = this.times + 1;
          if (res.data.hasLunch) this.times = this.times + 1;
          if (res.data.hasDinner) this.times = this.times + 1;
          if (this.times > 0) {
            this.timer = setTimeout(() => {
              this.getInfo();
            }, 1000 * 5 * 60);
          }
        } else if (res.code == 10501) {
          Dialog.confirm({
            title: "",
            message: res.message,
            confirmButtonText: "前往核销",
            cancelButtonText: "返回"
          })
            .then(() => {
              this.$router.push("/canteenForM/scanVerify");
            })
            .catch(() => {
              this.$router.push("/canteenForUser/login");
            });
        } else {
          Toast(res.message);
          if (res.code == 4000) {
            setTimeout(() => {
              this.$router.push("/canteenForUser/login");
            }, 2000);
          }
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.navbar {
  .van-nav-bar {
    background-color: #fff;
  }
  .van-nav-bar .van-nav-bar__text {
    color: #999;
    font-size: 14px;
  }
  .van-nav-bar .van-icon {
    color: #333;
    font-size: 18px;
  }
  .van-nav-bar .van-nav-bar__title {
    color: #333;
    font-size: 18px;
  }
}
.header {
  height: 140px;
  background: #f7b52b;
  text-align: center;
  padding-top: 28px;
  color: #fff;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  letter-spacing: 2px;
  .date {
    font-size: 15px;
    font-weight: 400;
    margin-top: 14px;
  }
}
.qrcode_wrapper {
  padding: 0 23px 20px;
  margin-top: -39px;
  font-family: PingFang SC;
  .qrcode_content {
    height: 465px;
    background: #ffffff;
    box-shadow: 0px 6px 7px 1px rgba(146, 146, 146, 0.15);
    border-radius: 10px;
    .qrcode {
      position: relative;
      text-align: center;
      padding-top: 60px;
      .ball {
        position: absolute;
        z-index: 10;
        width: 15px;
        height: 15px;
        left: -7px;
        top: -7px;
        background: #fff;
        border-radius: 50%;
        box-shadow: -4px 0px 4px 0px rgba(146, 146, 146, 0.15) inset;
      }
      .ball2 {
        position: absolute;
        z-index: 10;
        width: 15px;
        height: 15px;
        right: -7px;
        top: -7px;
        background: #fff;
        border-radius: 50%;
        box-shadow: 4px 0px 4px 0px rgba(146, 146, 146, 0.15) inset;
      }
      .qrcode_img {
        width: 180px;
        margin: 0 auto 10px;
        height: 180px;
      }
      .tip_img {
        width: 222px;
        height: 134px;
        margin-bottom: 10px;
      }
      .tip {
        color: #666;
        font-size: 14px;
        letter-spacing: 2px;
      }
    }
    .user_info {
      height: 91px;
      padding: 0 21px;
      display: flex;
      align-items: center;
      vertical-align: middle;
      border-bottom: 1px dashed #bfbfbf;
      img {
        width: 60px;
        height: 40px;
        margin-right: 19px;
      }
      .name {
        font-size: 18px;
        line-height: 18px;
        margin-bottom: 9px;
        font-weight: 500;
        color: #333;
      }
      .company {
        color: #666666;
        font-size: 14px;
      }
    }
  }
}
</style>
